import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Revisione } from "../types"
import { API_URL } from "../constants"

export function useRevisioniList(params: Record<string, string> = {}) {
  return useList<Revisione>(`${API_URL}/revisioni`, {
    query: params,
  })
}

export function useRevisione(id: number | undefined | string) {
  return useDetail<Revisione>(`${API_URL}/revisioni`, id?.toString())
}

export function useRevisioneCreate() {
  return useCreate<Revisione>(`${API_URL}/revisioni`)
}

export function useRevisioneUpdate() {
  return useUpdate<Revisione>(`${API_URL}/revisioni`)
}

export function useRevisioneDelete() {
  return useDelete<Revisione>(`${API_URL}/revisioni`)
}